import { VehicleRepository } from 'core/repositories/VehicleRepository';
import { createDependency } from 'services/createDependency';

export const [useVehicleRepository, withVehicleRepository] = createDependency<VehicleRepository>();
